import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdType } from 'src/components/competitive-intelligence/types';

export type SortBy = 'Freq.' | 'Position' | 'Price';
export type SortDirection = 'asc' | 'desc';

export interface AdsUiState {
  adType: AdType;
  searchQuery: string;
  sortBy: SortBy;
  sortDirection: SortDirection;
}

const initialState: AdsUiState = {
  adType: 'ALL',
  searchQuery: '',
  sortBy: 'Freq.',
  sortDirection: 'desc',
};

const adsUiSlice = createSlice({
  name: 'competitiveIntelligenceAdsUi',
  initialState,
  reducers: {
    setAdType(state, action: PayloadAction<AdType>) {
      state.adType = action.payload;
    },
    setSearchQuery(state, action: PayloadAction<string>) {
      state.searchQuery = action.payload;
    },
    setSortBy(state, action: PayloadAction<SortBy>) {
      state.sortBy = action.payload;
    },
    setSortDirection(state, action: PayloadAction<SortDirection>) {
      state.sortDirection = action.payload;
    },
    resetAdsUi(state) {
      Object.assign(state, initialState);
    },
  },
});

export const { setAdType, setSearchQuery, setSortBy, setSortDirection, resetAdsUi } = adsUiSlice.actions;
export default adsUiSlice.reducer;

